import { EnumTransferOrderStep } from '../../../../../constants/enum';
import * as actions from '../../../../../constants/actionTypes';

const initialState = {
  stepId: EnumTransferOrderStep.SELECT_BRANCH.id,
  transferredOrder: null,
  selectedBranch: null,
  newBranchData: null,
  newBranchError: null,
};

function transferOrderReducer(state = initialState, action) {
  const { response, type } = action;

  switch (type) {
    case actions.START_TRANSFERRING_ORDER: {
      return {
        ...state,
        stepId: EnumTransferOrderStep.SELECT_BRANCH.id,
        transferredOrder: { ...response },
        selectedBranch: null,
        newBranchData: null,
        newBranchError: null,
        changeBranchError: null,
      };
    }

    case actions.STOP_TRANSFERRING_ORDER: {
      return {
        ...state,
        stepId: EnumTransferOrderStep.SELECT_BRANCH.id,
        transferredOrder: null,
        selectedBranch: null,
        newBranchData: null,
        newBranchError: null,
        changeBranchError: null,
      };
    }

    case actions.TRANSFERRED_BRANCH_SELECTED: {
      return {
        ...state,
        selectedBranch: response,
      };
    }

    case actions.GO_TO_VERIFYING_STEP: {
      return {
        ...state,
        stepId: EnumTransferOrderStep.VERIFY_BRANCH.id,
      };
    }

    case actions.ATTEMPT_CHANGE_RESTAURANT_SUCCESSFULLY: {
      return {
        ...state,
        stepId: EnumTransferOrderStep.TRANSFER_CONFIRM.id,
        newBranchData: response,
        newBranchError: null,
      }
    }

    case actions.ATTEMPT_CHANGE_RESTAURANT_FAILED: {
      return {
        ...state,
        newBranchData: null,
        newBranchError: response,
      }
    }

    case actions.CHANGE_RESTAURANT_FAILED: {
      return {
        ...state,
        stepId: EnumTransferOrderStep.TRANSFER_ERROR.id,
      }
    }

    default:
      return state;
  }
}

export default transferOrderReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/TransferOrder/reducers.js